<table class="table table-bordered" id="table" width="100%" cellspacing="0">
  <thead>
    <tr>
      <th>{{ paymentI18n?.nameI18n }}</th>
      <th>{{ paymentI18n?.dateI18n }}</th>
      <th>{{ paymentI18n?.amountI18n }}</th>
      <th></th>
    </tr>
  </thead>
  <tfoot>
    <tr>
      <th>{{ paymentI18n?.nameI18n }}</th>
      <th>{{ paymentI18n?.dateI18n }}</th>
      <th>{{ paymentI18n?.amountI18n }}</th>
      <th></th>
    </tr>
  </tfoot>
  <tbody *ngIf="payments.length > 0">
    <tr *ngFor="let c of payments">
      <td>{{ c.memberName.name }}</td>
      <td>{{ c.date }}</td>
      <td>{{ c.amount }}</td>
      <td>
        <button
          type="button"
          class="btn btn-danger btn-sm"
          (click)="delete(c.id)"
        >
          <i class="fas fa-trash-alt"></i>
        </button>
      </td>
    </tr>
  </tbody>
</table>
